import React from 'react';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import styles from './blank-column-content.styles';

function BlankColumnContent() {
  return (<View style={styles.root} />);
}

export default pure(BlankColumnContent);
